/**
 * 閲覧者の国コードを返すパス。SPA 配信用 CloudFront の CloudFront Function が応答する
 * (infra の GEO_PATH_PATTERN と一致させること)。API の base URL ではなく SPA と同一オリジン。
 */
export const GEO_PATH = '/geo';

/** 初期値の推定のためにフォームの表示を待たせすぎないための上限。 */
export const GEO_TIMEOUT_MS = 1500;

interface GeoResponse {
  country?: unknown;
}

/**
 * IP から推定した国コードを返す。判定できなければ null。
 *
 * 失敗時は例外を投げる。呼び出し側はロケールによる推定にフォールバックする。
 */
export async function fetchGeoCountry(signal?: AbortSignal): Promise<string | null> {
  // AbortSignal.any / AbortSignal.timeout は古い iOS Safari に無いため自前で合成する
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), GEO_TIMEOUT_MS);
  signal?.addEventListener('abort', () => controller.abort(), { once: true });

  try {
    const response = await fetch(GEO_PATH, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      throw new Error(`geo request failed: ${response.status}`);
    }
    // ローカル開発 (Vite) では /geo が無く index.html が 200 で返るため、型で判定する
    const contentType = response.headers.get('Content-Type') ?? '';
    if (!contentType.includes('application/json')) {
      throw new Error('geo response is not JSON');
    }
    const body = (await response.json()) as GeoResponse;
    return typeof body.country === 'string' ? body.country : null;
  } finally {
    clearTimeout(timer);
  }
}
